export function scrollTop(): void {
  window.scrollTo({
    top: 0,
    behavior: 'smooth',
  });
}
